import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';


function WrapWithLoader(props) {
  const {classes, loading, className} = props;

  return (
    <div className={`${classes.wrapper} ${className}`}>
      {props.children}
      {loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
    </div>
  );
}

const styles = (theme) => ({
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

export default withStyles(styles)(WrapWithLoader);



// WEBPACK FOOTER //
// ./src/parts/WrapWithLoader.js